import { render, staticRenderFns } from "./SAMonitor.vue?vue&type=template&id=ce70d18e&scoped=true&"
import script from "./SAMonitor.vue?vue&type=script&lang=js&"
export * from "./SAMonitor.vue?vue&type=script&lang=js&"
import style0 from "./SAMonitor.vue?vue&type=style&index=0&id=ce70d18e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce70d18e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VCardTitle,
  VChip,
  VContainer,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
})
